import SessionExpiredModal from './session-expired-modal';

export default SessionExpiredModal;
